<template>
  <div :class="classList">
    <router-link
      to=""
      v-if="blockUser"
      @click.native="$emit('unBlockUser')"
      class="btn btn--static-md btn--green"
    >
      <icon name="user-pass-icon-2" />
      <span> שחרור מנעילה</span>
    </router-link>
    <router-link
      to=""
      v-else
      class="btn btn--static-md btn--red"
      @click.native="$emit('blockUser')"
    >
      <!-- <icon name="user-pass-icon-2" /> -->
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 9V5.88889C6 4.85749 6.42143 3.86834 7.17157 3.13903C7.92172 2.40972 8.93913 2 10 2C11.0609 2 12.0783 2.40972 12.8284 3.13903C13.5786 3.86834 14 4.85749 14 5.88889V9M4.55556 9H15.4444C16.3036 9 17 9.73263 17 10.6364V16.3636C17 17.2674 16.3036 18 15.4444 18H4.55556C3.69645 18 3 17.2674 3 16.3636V10.6364C3 9.73263 3.69645 9 4.55556 9Z"
          stroke="#FF6052"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <span>חסימת גישה</span>
    </router-link>
    <div class="sep-line mx-4 user-line"></div>
    <router-link
      to=""
      class="btn btn--static-md btn--blue"
      @click.native="$emit('changePasswordModal')"
    >
      <!-- <icon name="user-change-password" /> -->
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 8V3M4 8H8M4 8C4.59334 6.9723 6.28182 5.14363 7.34613 4.61877C8.41044 4.09391 9.60649 3.89644 10.783 4.05134C11.9596 4.20623 13.0637 4.70653 13.9559 5.48897C14.7305 6.16822 15.3151 7.03362 15.6567 8M16 12C15.4045 13.0846 13.7474 14.8464 12.6359 15.39C11.5245 15.9336 10.2721 16.1204 9.05043 15.9246C7.82873 15.7289 6.69742 15.1602 5.81145 14.2965C5.14922 13.651 4.64828 12.8642 4.34277 12M16 12V17M16 12H12"
          stroke="#5A6F95"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <span>שינוי סיסמה</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'UserControls',
  props: {
    blockUser: {
      type: Boolean,
      default: false
    },
    classList: {
      type: String,
      default: ''
    }
  }
};
</script>
<style scoped>
::v-deep .btn--red {
  background: transparent !important;
  color: #38455d !important;
  font-weight: 400;
  font-size: 14px !important;
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: 8px;
}
::v-deep .btn--red:hover {
  transition: 0.3s;
  background: #e5f2ff !important;
}
::v-deep .btn--blue {
  background: transparent !important;
  color: #38455d !important;
  font-weight: 400;
  font-size: 14px !important;
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: 8px;
}
::v-deep .btn--blue:hover {
  transition: 0.3s;
  background: #e5f2ff !important;
  box-shadow: none !important;
}
::v-deep .btn--red svg {
  stroke: #5a6f95 !important;
}
</style>
